import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import { BackButton } from '../../ui/BackButton'
import { Icon } from '../../ui/Icon'
import { Photo } from '../../ui/Photo'
import { Failed, Loading } from '../../ui/Load'
import { categoryTint } from '../../ui/product'
import { useCategories } from './api'

/** Все категории витрины списком; строка ведёт в каталог этой категории. */
export function CategoriesScreen() {
  const navigate = useNavigate()
  const { t } = useTranslation(['catalog', 'common'])
  const categories = useCategories()
  const list = categories.data ?? []

  return (
    <section className="screen cats-wrap">
      <div className="mhead">
        <BackButton to="/" />
        <h1>{t('catalog:categories')}</h1>
      </div>

      {categories.isPending ? <Loading what={t('common:state.loading')} count={6} /> : null}
      {categories.isError ? (
        <Failed
          error={categories.error}
          onRetry={() => {
            void categories.refetch()
          }}
        />
      ) : null}
      {categories.data && list.length === 0 ? (
        <div className="card empty">
          <Icon name="i-grid" size={54} />
          <div className="t">{t('catalog:noCategories')}</div>
        </div>
      ) : null}

      {list.length > 0 ? (
        <div className="card cats-list">
          {list.map((category) => (
            <Press
              key={category.id}
              squish="row"
              className="cat-row"
              onPress={() => {
                void navigate(`/catalog?cat=${category.id}`)
              }}
            >
              <span className="ti" style={{ background: categoryTint(category.id) }}>
                <Photo src={category.cover} alt="" icon="i-jar" iconSize={24} />
              </span>
              <span className="cr-b">
                <span className="tn">{category.name}</span>
                <span className="cr-m num">
                  {t('catalog:goods', { count: category.products })} ·{' '}
                  <b>{t('catalog:cashback', { percent: category.cb })}</b>
                </span>
              </span>
              <Icon name="i-chev" size={18} />
            </Press>
          ))}
        </div>
      ) : null}
    </section>
  )
}
